<section class="bg-shl-navy py-12 text-white">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="grid grid-cols-2 gap-8 md:grid-cols-4">
      <div class="flex flex-col border-s-2 border-shl-sky ps-6">
        <span class="text-4xl font-bold tracking-tight text-white">15<span class="text-shl-sky">+</span></span>
        <span class="text-sm font-medium text-blue-200 mt-1">{{ 'stats.years_experience' | translate }}</span>
      </div>
      <div class="flex flex-col border-s-2 border-shl-sky ps-6">
        <span class="text-4xl font-bold tracking-tight text-white">50k<span class="text-shl-sky">+</span></span>
        <span class="text-sm font-medium text-blue-200 mt-1">{{ 'stats.tons_shipped' | translate }}</span>
      </div>
      <div class="flex flex-col border-s-2 border-shl-sky ps-6">
        <span class="text-4xl font-bold tracking-tight text-white">98<span class="text-shl-sky">%</span></span>
        <span class="text-sm font-medium text-blue-200 mt-1">{{ 'stats.on_time_delivery' | translate }}</span>
      </div>
      <div class="flex flex-col border-s-2 border-shl-sky ps-6">
        <span class="text-4xl font-bold tracking-tight text-white">24/7</span>
        <span class="text-sm font-medium text-blue-200 mt-1">{{ 'stats.customer_support' | translate }}</span>
      </div>
    </div>
  </div>
</section>
